import { render, staticRenderFns } from "./PageWineLeft.vue?vue&type=template&id=2605b587"
import script from "./PageWineLeft.vue?vue&type=script&lang=ts"
export * from "./PageWineLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports